import { useCallback } from "react";
import toast from "react-hot-toast";

import { AxiosError } from "axios";

import { DefaultApiError } from "../services/types";


export function useShowNotification() {
    
    const showSucessNotification = useCallback(
        (message: string) => {
            toast.success(message);
        },
        []
    );

    const showErrorNotification = useCallback(
        (
            error: AxiosError<DefaultApiError> | DefaultApiError | null,
            defaultMessage: string
        ) => {
            const axiosError = error as AxiosError<DefaultApiError>;
            const defaultError = error as DefaultApiError;

            let message = defaultMessage;
            if (axiosError?.response?.data?.mensagem) {
                message = axiosError.response.data.mensagem;
            } else if (axiosError?.message) {
                message = axiosError.message;
            } else if (defaultError?.mensagem) {
                message = defaultError.mensagem;
            }

            let code = null;
            if (axiosError?.response?.data?.codigoErro) {
                code = axiosError.response.data.codigoErro;
            } else if (axiosError?.code) {
                code = axiosError.code;
            } else if (defaultError?.codigoErro) {
                code = defaultError.codigoErro;
            }

            toast.error(`${message} (${code})`);
        },
        []
    );

    return { showSucessNotification, showErrorNotification };
}